import './CreateEventCard.scss'
import React, { useState, useContext } from 'react'

import CreateEventModal from 'components/Modals/CreateEventModal'
import { OrganizationContext } from 'components/Contexts/OrganizationProvider'

import { useTranslation } from 'react-i18next'

const PlusIcon = () => (
  <svg width="38px" height="38px" viewBox="0 0 20 20" className="PlusIcon">
    <g>
      <path d="M10.5263158,9.47368421 L20,9.47368421 L20,10.5263158 L10.5263158,10.5263158 L10.5263158,20 L9.47368421,20 L9.47368421,10.5263158 L0,10.5263158 L0,9.47368421 L9.47368421,9.47368421 L9.47368421,0 L10.5263158,0 L10.5263158,9.47368421 Z" />
    </g>
  </svg>
)

const DisabledIcon = () => (
  <svg
    width="56px"
    height="56px"
    viewBox="0 0 56 56"
    fill="none"
    className="DisabledIcon">
    <path
      d="M28.5202 50.3743C40.5896 50.3743 50.3738 40.5901 50.3738 28.5206C50.3738 16.4512 40.5896 6.66699 28.5202 6.66699C16.4507 6.66699 6.6665 16.4512 6.6665 28.5206C6.6665 40.5901 16.4507 50.3743 28.5202 50.3743Z"
      stroke="#737373"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.5444 13.4961L13.4956 43.5449"
      stroke="#737373"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const CreateEventCard = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const { t } = useTranslation()
  const { settings } = useContext(OrganizationContext)

  const isEventCreationDisabled =
    settings?.organization?.event_creation_disabled === true

  return (
    <div
      className={`CreateEventCard ${
        isEventCreationDisabled ? 'disabled' : ''
      }`}>
      <button
        onClick={() => !isEventCreationDisabled && setModalIsOpen(true)}
        className="CreateEventButton"
        disabled={isEventCreationDisabled}>
        {isEventCreationDisabled ? <DisabledIcon /> : <PlusIcon />}
      </button>
      {modalIsOpen && !isEventCreationDisabled && (
        <CreateEventModal handleClose={() => setModalIsOpen(false)} />
      )}
      <div className="meta">
        <h3 className="title">
          {isEventCreationDisabled
            ? t('event creation disabled')
            : t('create new')}
        </h3>
      </div>
    </div>
  )
}

export default CreateEventCard
